"use client";

import React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const legalLinks = [{
  label: "Personvernerklæring",
  href: "/PrivacyPolicyPage"
}, {
  label: "Brukervilkår",
  href: "/TermsOfUsePage"
}, {
  label: "Informasjonskapsler",
  href: "/CookiesPage"
}];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}];
export default function Footer() {
  return <section id="footer" className="bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://xora.no/wp-content/uploads/2026/04/LOGO.png" alt="Xora Logo" className="h-26 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Banebrytende AI-teknologi skreddersydd for eiendomsmarkedet. Vi automatiserer hverdagen din slik at du kan fokusere på salg.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6">
              Hurtiglenker
            </h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6">
              Juridisk
            </h3>
            <ul className="space-y-3">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6">
              Kontakt Oss
            </h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground text-sm">
                <MapPin className="size-5 shrink-0 text-primary" />
                <span>Skotselv, Øvre Eiker</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Phone className="size-5 shrink-0 text-primary" />
                <span>+47 95 42 42 26</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm">
                <Mail className="size-5 shrink-0 text-primary" />
                <span>hei@xora.no</span>
              </li>
            </ul>

            
          </div>
        </div>

        <Separator className="mb-8 bg-border/50" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Xora. Med enerett.</p>
          <p>
            Designet for fremtidens eiendomsmeglere.
          </p>
        </div>
      </div>
    </section>;
}